module.exports = __webpack_public_path__ + "static/media/people.8d22d69a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dashboard/bfile_result/people.svg
// module id = 3002
// module chunks = 0